import React from 'react';
import EducationCard from "./EducationCard";
import {
    Container,
    Row,
    Jumbotron
} from "react-bootstrap";

const Education = ({education}) => {
    return (  
        <section className="section bg-light">
            <Container className="bg-light">
                <Jumbotron fluid className="bg-light">
                    <h2 className="display-4 mb-5 text-center">
                        {education.heading}
                    </h2>
                    <Row>
                        {
                            education.data.map(data => {
                                return <EducationCard key={data.university} data={data} />
                            })
                        }
                    </Row>
                </Jumbotron>
            </Container>
        </section>
    );
}
 
export default Education;